import config from 'constants/config'
import createSelector from 'lib/web/createSelector'
import { isEnabledForFeature } from 'lib/config/featureFlagUtils'

export const showTaxExclusivePrices = createSelector(
  (state: App.State) => state.checkout.cart.regionCode || state.geo.currentRegionCode,
  (regionCode): boolean => isEnabledForFeature(config.TAX_EXCLUSIVE_REGIONS, regionCode),
)
